<template>
    <div class="col-12 px-3 my-2">
        <div class="row">
            <div class="col-12">
                <h2 class="mb-4">Confirm your name and signature</h2>
            </div>
        </div>

        <div class="card mt-1" id="sign-pad">
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-12 col-md-6 mb-3">
                        <label for style="font-weight: bold;">Enter Name Here</label>
                        <input
                            type="text"
                            class="form-control"
                            id="name"
                            v-model="appl.full_name"
                            v-if="appl"
                            @input="drawFromText"
                        />
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <label for style="font-weight: bold;">Date</label>
                        <input
                            type="text"
                            class="form-control"
                            id="date"
                            v-model="date"
                            readonly
                        />
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-8">
                        <el-switch
                            v-model="isDraw"
                            active-text="Draw Signature"
                            inactive-text="System Design"
                        ></el-switch>
                    </div>
                    <div class="col-4" v-if="!isDraw">
                        <select
                            class="select-belt"
                            v-model="selectedFont"
                            style="float:right;"
                            @change="drawFromText"
                        >
                            <option :value="font" v-for="font in fonts" :key="font">
                                {{ font }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div
                        class="col-12 d-flex flex-column position-relative"
                        id="signature-pad-outer-div"
                        ref="signature_pad_outer_div"
                    >
                        <label for="signature" style="font-weight: bold;" v-if="isDraw">
                            Sign Here Using Your Mouse or Touch Screen ( Your Contract will be
                            signed in all the correct places).
                        </label>
                        <canvas
                            id="signature-pad-1"
                            ref="signature_pad_1"
                            class="signature-pad"
                            style="border: 1px solid #CDD4DA; border-radius: 5px;"
                        ></canvas>
                        <button
                            class="btn-red position-absolute"
                            id="signature-pad-clear-btn"
                            style="top: 179px; right: 23px;"
                            v-if="isDraw"
                            @click="erase"
                        >
                            Erase Signature
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 px-0 my-1">
            <p>
                By selecting Save and Adopt Signature, I agree that the signature will
                be the electronic representation of my signature when I use it on these
                documents, just the same as with a pen-and-paper signature.
            </p>
        </div>

        <div class="col-12 px-0 my-1">
            <button
                class="btn-green py-2 w-100 align-item-center"
                type="button"
                id="approve-btn"
                style="font-size: large;"
                :disabled="submitted"
                @click="saveSignature"
            >
                Submit
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        storeUrl: {
            required: true,
            type: String
        },
        application: {
            required: true,
            type: Object
        },
        applicant: {
            required: true,
            type: Object
        },
        successPage: {
            required: false,
            type: [String]
        }
    },
    data() {
        return {
            agree: false,
            showPad: true,
            submitted: false,
            loading: false,
            date: this.$moment(new Date()).format("DD/MM/YYYY"),
            sig1: null,
            appl: null,
            c1: null,
            isDraw: true,
            selectedFont: "Bad Script",
            fonts: [
                "Bad Script", // results of this terrible nightmare
                "Homemade Apple",
                "Mr De Haviland", // more satisfaction on bed,
                "Sacramento"
            ]
        };
    },
    methods: {
        drawFromText() {
            if (!this.isDraw) {
                this.sig1.clear(); // always clear on update text;
                let context = this.c1.getContext("2d");
                // context.font =
                //   `${this.selectedFont === "Homemade Apple" ? "45px" : "60px"} ` +
                //   this.selectedFont;

                if (this.selectedFont == "Bad Script")
                    context.font = "40px " + this.selectedFont;
                else if (this.selectedFont == "Homemade Apple")
                    context.font = "40px " + this.selectedFont;
                else context.font = "55px " + this.selectedFont;

                context.fillText(this.appl.full_name, 30, 100);
            }
        },
        saveSignature(e) {
            if (this.isDraw && this.sig1.isEmpty()) {
                return alert("Please provide a signature first.");
            }

            $(e.target).attr('disabled', true);
            $(e.target).text("SUBMITTING ... PLEASE WAIT");

            let canvas = this.isDraw ? this.sig1 : this.c1;
            let data = canvas.toDataURL("image/png");
            let sig = this.download(data);

            let formData = new FormData();
            formData.append("signature", sig);
            formData.append("name", this.appl.full_name);
            formData.append("date", this.date);
            axios
                .post(this.storeUrl, formData, {
                    headers: {"Content-Type": "multipart/form-data"}
                })
                .then(res => {
                    this.submitted = true;
                    location.href = this.successPage;
                })
                .catch(err => {
                    this.$message({
                        message: "Cannot Submit Contract Signature",
                        type: "error"
                    });
                    console.error(err);
                    $(e.target).attr('disabled', false);
                    $(e.target).text("Submit");
                });
        },
        dataURLToBlob(dataURL) {
            // Code taken from https://github.com/ebidel/filer.js
            var parts = dataURL.split(";base64,");
            var contentType = parts[0].split(":")[1];
            var raw = window.atob(parts[1]);
            var rawLength = raw.length;
            var uInt8Array = new Uint8Array(rawLength);

            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }

            return new Blob([uInt8Array], {type: contentType});
        },
        download(dataURL) {
            let blob = this.dataURLToBlob(dataURL);
            return blob;
        },
        erase() {
            this.sig1.clear();
        },
        handleResize() {
            let width = this.$refs.signature_pad_outer_div.clientWidth;
            let height = 200; //width / 2
            this.c1.width = width;
            this.c1.height = height;
            this.sig1.clear();
        }
    },
    mounted() {
        this.appl = this.applicant;
        this.appl.full_name = `${this.appl.first_name} ${this.appl.last_name}`;
        this.c1 = this.$refs.signature_pad_1;
        this.sig1 = new SignaturePad(this.c1, {
            backgroundColor: "rgb(255, 255, 255, 0)"
        });
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        this.showPad = true;
    },
    watch: {
        isDraw(newVal, oldVal) {
            this.sig1.clear();
            if (!newVal) {
                //   on update from switch
                this.drawFromText();
            }
        },
        selectedFont(newVal, oldVal) {
        }
    }
};
</script>

<style lang="sass">
.el-switch__core
    display: none !important
</style>
